// "Salvar como" do Windows para PDF gerado no servidor (pedido dele, 22/10/2026: dar nome ao
// arquivo ou escolher um existente para sobrepor, sempre comecando em Downloads).
//
// A janela so abre colada ao clique: chamar escolherArquivoPdf ANTES de qualquer outro await
// (salvar, buscar catalogo, gerar). Baixar sozinho depois do Puppeteer nao serve — o Chrome do
// Ruan descartou o a.click() calado (DA-571, caso de 22/10/2026).

// Arquivo escolhido no "Salvar como" (showSaveFilePicker, so Chrome/Edge de computador).
export type ArquivoDestino = {
  name: string;
  createWritable: () => Promise<{ write: (dados: Blob) => Promise<void>; close: () => Promise<void> }>;
};

// 'cancelado' = ele fechou a janela, nada deve ser gerado. null = navegador sem a janela
// (Firefox, Safari) ou falha ao abrir: quem chama gera e oferece a janela "PDF pronto".
export async function escolherArquivoPdf(nomeSugerido: string): Promise<ArquivoDestino | null | 'cancelado'> {
  const abrir = (window as unknown as { showSaveFilePicker?: (o: unknown) => Promise<ArquivoDestino> }).showSaveFilePicker;
  if (!abrir) return null;
  try {
    return await abrir({
      suggestedName: nomeSugerido,
      // Sem `id`, o startIn vence a ultima pasta usada (algoritmo "determine the directory the
      // picker will start in" da spec WICG).
      startIn: 'downloads',
      types: [{ description: 'PDF', accept: { 'application/pdf': ['.pdf'] } }],
    });
  } catch (e) {
    if (e instanceof DOMException && e.name === 'AbortError') return 'cancelado';
    return null;
  }
}

export async function gravarPdf(destino: ArquivoDestino, pdf: Blob): Promise<void> {
  const gravador = await destino.createWritable();
  await gravador.write(pdf);
  await gravador.close();
}
